'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'

import FeaturedProductsPopup from '@/app/_components/FeaturedProductsPopup'
import { useSlideshow } from './SlideshowContext'

import '@/app/_styles/home_mobile_slideshow.css'

/**
 * Home page mobile slideshow that syncs current slide with context
 * for footer banner synchronization
 */
const HomeMobileSlideshow = ({ slides }) => {
    const { setCurrentSlide } = useSlideshow()

    // Select random slide client-side to avoid hydration mismatch
    const [slide, setSlide] = useState(null)

    useEffect(() => {
        if (slides?.length > 0) {
            const randomIndex = Math.floor(Math.random() * slides.length)
            const selectedSlide = slides[randomIndex]
            setSlide(selectedSlide)
            setCurrentSlide(selectedSlide)
        }
    }, [slides, setCurrentSlide])

    // Don't render until slide is selected client-side
    if (!slide) {
        return <div className="mobile-diptych" />
    }

    return (
        <>
            <div className="mobile-diptych">
                <div className="flex w-full h-full">
                    <div className="relative w-1/2 h-full">
                        <Image
                            src={slide.mobileLeftImage.src}
                            alt={slide.mobileLeftImage.alt}
                            fill
                            priority
                            fetchPriority="high"
                            quality={75}
                            sizes="(min-width: 768px) 0px, 50vw"
                            className="object-cover object-bottom"
                        />
                    </div>
                    <div className="relative w-1/2 h-full">
                        <Image
                            src={slide.mobileRightImage.src}
                            alt={slide.mobileRightImage.alt}
                            fill
                            priority
                            fetchPriority="high"
                            quality={75}
                            sizes="(min-width: 768px) 0px, 50vw"
                            className="object-cover object-bottom"
                        />
                    </div>
                </div>
            </div>
            <FeaturedProductsPopup
                products={slide.featured_products}
                position="bottom-left"
            />
        </>
    )
}

export default HomeMobileSlideshow
